import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import { DetectedBrandTerm, DetectedBrandTermSkeleton } from 'src/components/DetectedBrandTerm';
import { useStyles } from './useStyles';
import { DetectedBrandTermDemo } from 'src/components/DetectedBrandTermDemo';

export const DetectedBrandTerms = ({
  className,
  items,
  loading,
  onApplyDetectedBrandTerm,
  onEditBrandTerm,
  disabled,
  customerHasAccessToPerformance,
  onBusinessBookDemoClick,
}) => {
  const styles = useStyles();
  

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.header}>
        <Typography className={styles.title}>Brand term rules</Typography>
      </div>

      {customerHasAccessToPerformance ? (
        <div className={styles.content}>
          {loading ? (
            <DetectedBrandTermSkeleton />
          ) : items.length === 0 ? (
            <Typography className={styles.labelEmpty}>No brand terms were found</Typography>
          ) : (
            items.map(({ brandTerm, termInText }) => (
              <DetectedBrandTerm
                className={styles.detectedBrandTerm}
                key={brandTerm.id}
                brandTerm={brandTerm}
                termInText={termInText}
                onApplyClick={onApplyDetectedBrandTerm}
                onEditClick={onEditBrandTerm}
                disabled={disabled}
              />
            ))
          )}
        </div>
      ) : (
        <DetectedBrandTermDemo
          onApplyClick={onApplyDetectedBrandTerm}
          onEditClick={onEditBrandTerm}
          onBusinessBookDemoClick={onBusinessBookDemoClick}
        />
      )}
    </div>
  );
};

DetectedBrandTerms.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool,
  onApplyDetectedBrandTerm: PropTypes.func.isRequired,
  onEditBrandTerm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  customerHasAccessToPerformance: PropTypes.bool,
  onBusinessBookDemoClick: PropTypes.func,
};

DetectedBrandTerms.defaultProps = {
  className: null,
  loading: false,
  disabled: false,
  customerHasAccessToPerformance: false,
  onBusinessBookDemoClick: null,
};
